export const TOUR_EVENT = 'tour_event'
export const TRACK_PLAYLISTED_FROM_SIM_SEARCH =
  'TRACK_PLAYLISTED_FROM_SIM_SEARCH'
export const TRACK_PLAYLISTED_FROM_SIM_TAB = 'TRACK_PLAYLISTED_FROM_SIM_TAB'
export type TourEventNames =
  | typeof TRACK_PLAYLISTED_FROM_SIM_SEARCH
  | typeof TRACK_PLAYLISTED_FROM_SIM_TAB
  | any
const descriptionMapping: Record<TourEventNames, string> = {}
export type MappedEventTypes = TourEventNames
export function getEventDescription(event: MappedEventTypes): string {
  return descriptionMapping[event] || event
}
